import type { ComponentPropsWithRef } from 'react';
import styled from 'styled-components';
import { PlaceholderCloudArrowUp, Text, theme } from '@frameio/vapor';
import TEXT from './generated/TEXT/NoUploads';

TEXT.DEFINE({
  /** Title shown when there are no uploads */
  noUploadsTitle: 'No Uploads',
  /** Description text explaining where uploads will appear */
  noUploadsDescription: 'In-progress and past uploads will show up here.',
});

export function NoUploads() {
  return (
    <Container>
      <PlaceholderCloudArrowUp />
      <TitleContainer variant="header">{TEXT.noUploadsTitle}</TitleContainer>
      <Text color="tertiary" variant="body">
        {TEXT.noUploadsDescription}
      </Text>
    </Container>
  );
}

const TitleContainer = styled(Text)<ComponentPropsWithRef<typeof Text>>`
  padding-bottom: ${theme.spaces[12]};
`;

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  justify-content: center;
  overflow: auto;
  padding: 0 ${theme.spaces[12]};
  text-align: center;
`;
